import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';
import type { Actions } from './types';

export const enum LimeProductLine {
  Homeowners = 'homeowners',
  Renters = 'renters',
  RentersEU = 'rentersEU',
  Pet = 'pet',
  Life = 'life',
  Car = 'car',
}

export interface RedirectToHomeProps {
  readonly initialPage?: LimeProductLine;
  readonly action?: Actions;
}

export type RedirectToHomeAction = ActionMessage<'redirectToHome', RedirectToHomeProps>;
export const redirectToHome = invokeAction('appAction', 'redirectToHome');
